import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import classNames from 'classnames';

import { getAlbumDateLabel } from '../../../../../util/album';
import CustomControl from '../../../../../components/global/CustomControl';
import PhotoGroupSelectionRow from './PhotoGroupSelectionRow';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
  }),
  photoGroupSelectionEnabled: PropTypes.bool,
  onAlbumClick: PropTypes.func.isRequired,
  selectedTargets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  isExpanded: PropTypes.bool,
  onPhotoGroupClick: PropTypes.func,
  disabledTargets: PropTypes.arrayOf(PropTypes.string),
};

const AlbumSelectionRow = ({
  album,
  selectedTargets = [],
  isExpanded,
  photoGroupSelectionEnabled,
  onAlbumClick,
  onPhotoGroupClick,
  disabledTargets = [],
}) => {
  const caretClasses = classNames({
    'ml-1': true,
    'caret-up': isExpanded,
    'caret-down': !isExpanded,
  });

  const hasPhotoGroups = (album.album_photo_groups?.records ?? []).length > 0;

  return (
    <Fragment>
      <tr
        key={album.id}
        onClick={event => {
          event.preventDefault();
          onAlbumClick();
        }}
      >
        <td className="text-left d-flex align-items-center">
          {photoGroupSelectionEnabled && hasPhotoGroups && (
            <Fragment>
              <span className={caretClasses} />
              <span className="text-sm ml-1">{album.name}</span>
            </Fragment>
          )}
          {(!photoGroupSelectionEnabled || !hasPhotoGroups) && (
            <CustomControl
              id={album.id}
              type="checkbox"
              checked={!!selectedTargets.find(({ id }) => id === album.id)}
              readOnly
              label={album.name}
              size="sm"
            />
          )}
        </td>
        <td className="text-left">
          {album.photos?.total > 0
            ? `${album.photos.total} ${pluralize('photo', album.photos.total)}`
            : 'N/A'}
        </td>
        <td className="text-left" colSpan={2}>
          {getAlbumDateLabel(album)}
        </td>
      </tr>
      {isExpanded && (
        // Render photo Groups:
        <Fragment>
          {!disabledTargets.includes(album.id) && (
            <PhotoGroupSelectionRow
              photoGroup={{
                ...album,
                // Clean up the ID & Name, but use the date as ref from the album
                name: 'Ungrouped Photos',
              }}
              selectedTargets={selectedTargets}
              onPhotoGroupClick={onPhotoGroupClick}
            />
          )}
          {(album.album_photo_groups?.records ?? []).map(photoGroup => {
            if (disabledTargets.includes(photoGroup.id)) {
              return null;
            }

            return (
              <PhotoGroupSelectionRow
                key={photoGroup.id}
                photoGroup={photoGroup}
                selectedTargets={selectedTargets}
                onPhotoGroupClick={onPhotoGroupClick}
              />
            );
          })}
        </Fragment>
      )}
    </Fragment>
  );
};

AlbumSelectionRow.propTypes = propTypes;

export default AlbumSelectionRow;
